import ReactSelect, { formatDotLabel, formatDotStyles } from '../ReactSelect';
import React from 'react';
import colors from '../../theme/colors';

export type CompliantReason =
  | 'ALL_COMPLIANT'
  | 'PASSING'
  | 'PENDING'
  | 'ALL_NONCOMPLIANT'
  | 'FAILING'
  | 'INSTALLATION'
  | 'PAST_DUE';

export type CompliantOption = {
  value: CompliantReason;
  label: string;
  color: string;
};

const compliantReasonOptions: {
  label: 'Compliant' | 'Noncompliant';
  options: CompliantOption[];
}[] = [
  {
    label: 'Compliant',
    options: [
      {
        value: 'ALL_COMPLIANT',
        label: 'All Compliant',
        color: colors.statusSuccess,
      },
      {
        value: 'PASSING',
        label: 'Passing',
        color: colors.statusSuccess,
      },
      {
        value: 'PENDING',
        label: 'Pending',
        color: colors.statusSuccess,
      },
    ],
  },
  {
    label: 'Noncompliant',
    options: [
      {
        value: 'ALL_NONCOMPLIANT',
        label: 'All Noncompliant',
        color: colors.statusError,
      },
      {
        value: 'FAILING',
        label: 'Failing',
        color: colors.statusError,
      },
      {
        value: 'INSTALLATION',
        label: 'Installation',
        color: colors.statusError,
      },
      {
        value: 'PAST_DUE',
        label: 'Past Due',
        color: colors.statusError,
      },
    ],
  },
] as const;

const isCompliant = (option: CompliantOption) => {
  return compliantReasonOptions
    .find((group) => group.label === 'Compliant')
    ?.options.find((opt) => opt.value === option.value);
};

const isNoncompliant = (option: CompliantOption) => !isCompliant(option);

export const AssemblyCompliancePicker = ({
  value,
  onChange,
}: {
  value?: CompliantReason[];
  onChange: (value?: CompliantReason[]) => void;
}) => {
  const selectedCompliantReasons: CompliantOption[] = [];
  if (Array.isArray(value)) {
    compliantReasonOptions.forEach((group) =>
      selectedCompliantReasons.push(
        ...group.options.filter((option) => value?.includes(option.value))
      )
    );
  }

  return (
    <ReactSelect
      placeholder="compliance"
      isMulti
      isClearable={false}
      styles={{
        menu: (base) => ({
          ...base,
          minWidth: '200px',
        }),
        multiValue: formatDotStyles,
      }}
      formatOptionLabel={formatDotLabel}
      onChange={(values, meta) => {
        if (Array.isArray(values)) {
          if (meta.action === 'select-option' && meta.option) {
            if (isCompliant(meta.option)) {
              if (meta.option.value === 'ALL_COMPLIANT') {
                values = values.filter(
                  (option) => option.value === 'ALL_COMPLIANT'
                );
              } else {
                values = values.filter(
                  (option) => option.value !== 'ALL_COMPLIANT'
                );
              }
            } else if (isNoncompliant(meta.option)) {
              if (meta.option.value === 'ALL_NONCOMPLIANT') {
                values = values.filter(
                  (option) => option.value === 'ALL_NONCOMPLIANT'
                );
              } else {
                values = values.filter(
                  (option) => option.value !== 'ALL_NONCOMPLIANT'
                );
              }
            }
          }

          onChange(
            values.length > 0 ? values.map((value1) => value1.value) : undefined
          );
        } else {
          onChange(undefined);
        }
      }}
      value={selectedCompliantReasons}
      options={compliantReasonOptions}
    />
  );
};
